<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="变更事项" >
            <template slot-scope="scope">
              {{ scope.row.modify_item_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="变更前内容">
            <template slot-scope="scope">
              {{ scope.row.modify_before_content || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="变更后内容">
            <template slot-scope="scope">
              {{ scope.row.modify_after_content || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="变更日期">
            <template slot-scope="scope">
              {{ scope.row.modify_date || '-' }}
            </template>
        </el-table-column>

    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'modifyRecordList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '变更记录',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>